(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    function formatVal(v, el) {
      var dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
      var suf = el.getAttribute('data-suffix') || '';
      var pre = el.getAttribute('data-prefix') || '';
      var num = dec ? v.toFixed(dec) : Math.round(v).toLocaleString();
      return pre + num + suf;
    }
    function animateCount(el) {
      var target = parseFloat(el.getAttribute('data-count')) || 0;
      var dur = 1200, start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = formatVal(target * eased, el);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    function finalizeCounter(el, animate) {
      var c = el.querySelector('[data-count]');
      if (!c || c.dataset.done) return;
      c.dataset.done = '1';
      if (animate) animateCount(c);
      else c.textContent = formatVal(parseFloat(c.getAttribute('data-count')) || 0, c);
    }
    function revealNow(el, animate) {
      el.classList.add('is-visible');
      finalizeCounter(el, animate);
    }
    function revealAll(scope) {
      (scope || document).querySelectorAll('.reveal').forEach(function (el) { revealNow(el, false); });
    }

    /* Scroll reveal + counters */
    if (designMode || reduce || !('IntersectionObserver' in window)) {
      // In the theme editor (or reduced-motion), never hide content.
      revealAll(document);
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          revealNow(entry.target, true);
          io.unobserve(entry.target);
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
      document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    }

    // When Shopify re-renders a section in the editor, reveal it immediately.
    if (designMode) {
      document.addEventListener('shopify:section:load', function (e) { revealAll(e.target); });
      document.addEventListener('shopify:section:select', function (e) { revealAll(e.target); });
      document.addEventListener('shopify:block:select', function (e) { revealAll(e.target); });
    }

    /* Collection filters + sort auto-submit */
    var collForm = document.getElementById('CollFilters');
    if (collForm) {
      collForm.addEventListener('change', function (e) {
        if (e.target.matches('.coll-filters input[type=checkbox], .coll-sort__select')) {
          collForm.submit();
        }
      });
    }

    /* Cart: quantity steppers + remove */
    var cartForm = document.getElementById('CartForm');
    if (cartForm) {
      cartForm.addEventListener('click', function (e) {
        var stepBtn = e.target.closest('[data-qty]');
        if (stepBtn) {
          var input = stepBtn.parentElement.querySelector('.qty__input');
          var val = parseInt(input.value, 10) || 0;
          val = stepBtn.getAttribute('data-qty') === 'plus' ? val + 1 : Math.max(0, val - 1);
          input.value = val;
          cartForm.submit();
          return;
        }
        var removeBtn = e.target.closest('[data-remove]');
        if (removeBtn) {
          var row = removeBtn.closest('.cart-item');
          var qtyInput = row.querySelector('.qty__input');
          qtyInput.value = 0;
          cartForm.submit();
        }
      });
    }

    /* Sticky header state */
    var header = document.querySelector('.site-header');
    if (header) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 24);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* Mobile nav toggle + dropdown accordions */
    var toggle = document.querySelector('.nav-toggle');
    var nav = document.getElementById('SiteNav');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      nav.addEventListener('click', function (e) {
        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        var link = e.target.closest('.nav-link');
        if (isMobile && link && link.parentElement.classList.contains('has-dropdown')) {
          e.preventDefault();
          link.parentElement.classList.toggle('open');
          return;
        }
        if (e.target.closest('a')) {
          nav.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });
})();
